import immutable from 'immutability-helper';
import { REHYDRATE } from 'redux-persist/lib/constants';
import { handleActions } from 'redux-actions';
import { ActionTypes } from '../constants';

// Define user's language. Different browsers have the user locale defined
// on different fields on the `navigator` object, so we make sure to account
// for these different by checking all of them
const language =
  (navigator.languages && navigator.languages[0]) || navigator.language || navigator.userLanguage;

export const appState = {
  locale: language,
  breadCrumbs: [],
  uploadingFiles: [],
};

export default {
  app: handleActions(
    {
      [REHYDRATE]: (state) =>
        immutable(state, {
          locale: { $set: language },
          breadCrumbs: { $set: [] },
          uploadingFiles: { $set: [] },
        }),
      [ActionTypes.UPDATE_BREADCRUMBS]: (state, action) => {
        const { breadCrumbs } = action.payload;
        return immutable(state, {
          breadCrumbs: { $set: breadCrumbs },
        });
      },
      [ActionTypes.UPDATE_INTERFACE_LANGUAGE]: (state, { payload }) => {
        const locale = payload.languageCode;
        return immutable(state, {
          locale: { $set: locale },
        });
      },
      [ActionTypes.UPLOAD_FILE_REQUEST]: (state, { payload }) => {
        const newFile = {
          id: payload.id,
          token: payload.token,
          started: true,
          finished: false,
          cancelled: false,
          fail: false,
          sentFileId: null,
          percentage: 0,
        };

        return immutable(state, {
          uploadingFiles: { $push: [newFile] },
        });
      },
      [ActionTypes.UPLOAD_FILE_UPDATE_PROGRESS]: (state, { payload }) =>
        immutable(state, {
          uploadingFiles: {
            $set: state.uploadingFiles.map((item) =>
              item.id === payload.id ? { ...item, percentage: payload.percentage } : item,
            ),
          },
        }),
      [ActionTypes.UPLOAD_FILE_SUCCESS]: (state, { payload }) => {
        const uploadingFiles = state.uploadingFiles.map((item) => {
          if (item.id === payload.id)
            return { ...item, finished: true, percentage: 100, sentFileId: payload.sentFileId };

          return item;
        });

        return immutable(state, {
          uploadingFiles: { $set: uploadingFiles },
        });
      },
      [ActionTypes.UPLOAD_FILE_CANCEL]: (state, { payload }) => {
        const uploadingFiles = state.uploadingFiles.map((item) =>
          item.id === payload.id ? { ...item, cancelled: true } : item,
        );

        return immutable(state, {
          uploadingFiles: { $set: uploadingFiles },
        });
      },
      [ActionTypes.UPLOAD_FILE_FAILURE]: (state, { payload }) => {
        const uploadingFiles = state.uploadingFiles.map((item) =>
          item.id === payload.id ? { ...item, fail: true } : item,
        );

        return immutable(state, {
          uploadingFiles: { $set: uploadingFiles },
        });
      },
    },
    appState,
  ),
};
